import axios_auth from "@/axios_auth";
import axios_box24 from "@/axios_box24";
import axios from "@/axios";
import EventBus from "@/EventBus";

export default {
  data() {
    return {};
  },
  methods: {
    getLocalItem() {
      let localItem = localStorage.getItem("parcel");
      localItem = JSON.parse(localItem);
      return localItem;
    },
    logout() {
      delete axios.defaults.headers.common["Authorization"];
      localStorage.removeItem("parcel");
      // EventBus.$emit('set_navigation', { title: 'Service Excellence' })
      return this.$router.replace("/login");
    },
    refreshToken() {
      let formData = {};
      let localItem = this.getLocalItem();
      if (localItem) {
        formData = {
          username: localItem.user_id,
          refresh_token: localItem.refreshToken,
          time_available: 14400,
        };
      } else {
        formData = {
          username: "",
          refresh_token: "",
          time_available: 14400,
        };
      }

      return axios_auth
        .post("/RefreshToken", JSON.stringify(formData))
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$router.replace("/login");
          return "error";
        });
    },
    setAuthHeader() {
      let localItem = localStorage.getItem("parcel");
      localItem = JSON.parse(localItem);
      if (localItem) {
        // console.log('header is set!!')
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + localItem.token;
      } else {
        delete axios.defaults.headers.common["Authorization"];
      }
      return true;
    },
    filterObject(objects, fieldName, filterText) {
      var result = [];
      if (objects) {
        objects.forEach((object) => {
          if (object[fieldName]) {
            var lowerObj = object[fieldName].toLowerCase();
            if (lowerObj.includes(filterText.toLowerCase())) {
              result.push(object);
            }
          }
        });
      }
      return result;
    },
    removeDuplicateObject(objects) {
      return objects.filter((elem, pos, arr) => {
        return arr.indexOf(elem) === pos;
      });
    },
    groupByData(array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
        result[item[key]].sort((a, b) => {
          return b.ORDER_DATE < a.ORDER_DATE
            ? 1
            : b.ORDER_DATE > a.ORDER_DATE
            ? -1
            : 0;
        });
      });

      return result;
    },
    removeItem(array, item) {
      for (var i in array) {
        if (array[i] == item) {
          array.splice(i, 1);
          break;
        }
      }
    },
    randomRef() {
      let charSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      let randomString = "";
      for (let i = 0; i < 6; i++) {
        let randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
      }
      //console.log("random", randomString);
      return randomString;
    },
    randomRefQR() {
      let charSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
      let randomString = "";
      for (let i = 0; i < 8; i++) {
        let randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
      }
      //console.log("random", randomString);
      return randomString;
    },
    getTokenBox24() {
      let bodyFormData = new FormData();
      bodyFormData.set("username", "lpn2box24");
      bodyFormData.set("password", "677329ef789d9da637f8dfddf48a1045");

      return axios_box24({
        method: "post",
        url: "/auth",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function(response) {
          //handle success
          return response;
        })
        .catch(function(response) {
          //handle error
          return response;
        });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      let blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
};
